import React, { useState, useEffect } from 'react';
import { Input, Button, Switch } from 'antd';
import { useFormik } from 'formik';
import useQueryParams from 'hooks/useQueryParams';
import AdSelect from 'components/Selects/AdSelect';
import AdsetNameSelect from 'components/Selects/AdsetNameSelect';
import CampaignSelect from 'components/Selects/CampaignSelect';
import Label from 'components/filterLabel';

const UserJourneyFilterForm = ({ stylesProps }) => {
  const { searchParams, removeParams, setUrlParams } = useQueryParams();
  const { user_id, event_id, adset_ids, ad_ids, campaign_ids, session_id } = searchParams;
  const [liveInterval, setLiveInterval] = useState(null);

  const parseIds = (value) => (value?.length ? value.split(',').map(Number) : []);

  useEffect(() => {
    formik.setValues({
      user_id: user_id || '',
      event_id: event_id || '',
      session_id: session_id || '',
      ad_ids: parseIds(ad_ids),
      adset_ids: parseIds(adset_ids),
      campaign_ids: parseIds(campaign_ids),
    });
  }, [user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids]);

  const formik = useFormik({
    initialValues: {
      user_id: user_id || '',
      event_id: event_id || '',
      session_id: session_id || '',
      ad_ids: parseIds(ad_ids),
      adset_ids: parseIds(adset_ids),
      campaign_ids: parseIds(campaign_ids),
    },
    onSubmit: handleFilter,
  });

  const handleResetForm = () => {
    const resetValues = {
      user_id: '',
      event_id: '',
      session_id: '',
      ad_ids: [],
      adset_ids: [],
      campaign_ids: [],
    };
    formik.setValues(resetValues);
    removeParams(Object.keys(resetValues));
  };

  const cleanFilters = (values) =>
    Object.fromEntries(
      Object.entries(values).filter(([, v]) => v != null && !(Array.isArray(v) && v.length === 0))
    );

  function handleFilter() {
    const filtersToSet = cleanFilters(formik.values);
    setUrlParams(filtersToSet);
  }

  const onLiveChange = (checked) => {
    formik.setFieldValue('live', checked);

    if (liveInterval) clearInterval(liveInterval);

    if (checked) {
      const interval = setInterval(() => {
        formik.submitForm();
      }, 2000);
      setLiveInterval(interval);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit} className='w-full'>
      <div className={`${stylesProps} grid items-end gap-2`}>
        <Label value={formik.values.user_id} htmlFor='user_id' label='User ID'>
          <Input
            placeholder='Enter User ID'
            allowClear
            type='number'
            value={formik.values.user_id}
            onChange={(e) => formik.setFieldValue('user_id', e.target.value)}
          />
        </Label>
        <Label value={formik.values.event_id} htmlFor='event_id' label='Event ID'>
          <Input
            placeholder='Enter Event ID'
            allowClear
            type='number'
            value={formik.values.event_id}
            onChange={(e) => formik.setFieldValue('event_id', e.target.value)}
          />
        </Label>
        <Label value={formik.values.session_id} htmlFor='session_id' label='Session ID'>
          <Input
            placeholder='Enter Session ID'
            allowClear
            type='number'
            value={formik.values.session_id}
            onChange={(e) => formik.setFieldValue('session_id', e.target.value)}
          />
        </Label>
        <Label value={formik.values.ad_ids?.length > 0} htmlFor='ad_ids' label='Ads'>
          <AdSelect
            multiple
            value={formik.values.ad_ids}
            onChange={(val) => formik.setFieldValue('ad_ids', val)}
          />
        </Label>
        <Label value={formik?.values?.adset_ids?.length > 0} htmlFor='adset_ids' label='Ad Sets'>
          <AdsetNameSelect
            multiple
            value={formik.values.adset_ids}
            onChange={(val) => formik.setFieldValue('adset_ids', val)}
          />
        </Label>
        <Label
          value={formik?.values?.campaign_ids?.length > 0}
          htmlFor='campaign_ids'
          label='Campaigns'
        >
          <CampaignSelect
            multiple
            className='w-full'
            value={formik.values.campaign_ids}
            onChange={(val) => formik.setFieldValue('campaign_ids', val)}
          />
        </Label>

        {/* <Switch className='w-fit' checked={formik.values.live} onChange={onLiveChange} /> */}
      </div>

      <div className='items-center justify-between gap-2 sm:flex mt-2'>
        <Button htmlType='button' onClick={handleResetForm} className='!w-fit'>
          Reset
        </Button>
        <Button type='primary' htmlType='submit' className='!w-fit ml-auto' onClick={handleFilter}>
          Filter
        </Button>
      </div>
    </form>
  );
};

export default UserJourneyFilterForm;
